import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Mail, ChevronLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal mengirim email");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-paper to-terra-50/30 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Link to="/login" className="inline-flex items-center gap-1 text-xs uppercase tracking-wider text-stone-500 hover:text-terra-700 mb-4">
          <ChevronLeft className="h-3 w-3" /> Login
        </Link>
        <div className="bg-white border border-stone-200 shadow-sm p-6 md:p-8">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-terra-700 mb-1">
            <Mail className="h-3 w-3" /> Lupa Kata Sandi
          </div>
          <h1 className="font-display text-2xl font-bold text-stone-900">Reset Kata Sandi</h1>
          <p className="text-sm text-stone-500 mt-1">Kami akan kirim tautan reset ke email Anda.</p>

          {done ? (
            <div className="mt-6 bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-900" data-testid="forgot-done">
              Jika email <span className="font-mono">{email}</span> terdaftar, instruksi reset telah dikirim. Cek inbox Anda (dan folder spam).
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="block text-[11px] uppercase tracking-wider text-stone-600 font-semibold mb-1">Email</label>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-stone-300 px-3 py-2.5 text-sm focus:border-terra-500 focus:outline-1 focus:outline-terra-500"
                  data-testid="forgot-email" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-terra-500 hover:bg-terra-600 text-white py-2.5 text-sm font-medium disabled:opacity-60" data-testid="forgot-submit">
                {loading ? "Mengirim…" : "Kirim Tautan Reset"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
